(function(angular) {
    'use strict';

    angular.module('wtUi', [
        'wtUi.wtSuiteContainer',
        'wtUi.wtMenu',
        'wtUi.wtTabs',
        'wtUi.wtNotifications',
        'wtUi.wtBreadcrumb',
        'wtUi.wtListDataTable',
        'wtUi.wtToggleSwitch',
        'wtUi.wtModal',
        'wtUi.wtSelectList',
        'wtUi.wtUtils',
        'wtUi.wtOverlay',
        'wtUi.wtFilters',
        'wtUi.wtNavigableDropdown',
        'wtUi.wtDynamicDropdown',
        'wtUi.onOuterClick',
        'wtUi.groupableSelector',
        'wtUi.leftRightArrow',
        'wtUi.wtGridTable',
        'wtApp.wtCommon',
        'wtApp.wtFormatFilters'
    ]);
})(window.angular);

// TODO To be moved to a proper polyfills place
// requestAnimationFrame polyfill
((function(window) {
    const vendors = ['ms', 'moz', 'webkit', 'o'];
    let lastTime = 0;

    for (let idx = 0; idx < vendors.length && !window.requestAnimationFrame; ++idx) {
        window.requestAnimationFrame = window[vendors[idx] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[idx] + 'CancelAnimationFrame']
            || window[vendors[idx] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function(callback) {
            const currTime = new Date().getTime();
            const timeToCall = Math.max(0, 16 - (currTime - lastTime));
            const id = window.setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);

            lastTime = currTime + timeToCall;

            return id;
        };
    }

    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
    }
})(window));
